import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface RecruiterAdminProtectedRouteProps {
  children: ReactNode;
}

export function RecruiterAdminProtectedRoute({ children }: RecruiterAdminProtectedRouteProps) {
  const { user, userRole, userRoleData, isLoading } = useAuth();

  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const isRecruiterAdmin = userRole === "admin" || 
    (userRole === "employee" && userRoleData?.employee_type === "recruter_admin");
  
  if (!isRecruiterAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
